import { useContext } from 'react';
import _ from 'underscore';

import { DataServiceContext } from '../server-context';

export const useIsInternalUser = () => {
  const serverContext = useContext(DataServiceContext);
  if (serverContext.CurrentUser && !_.isUndefined(serverContext.CurrentUser.IsInternal)) {
    return serverContext.CurrentUser.IsInternal;
  }
  return false;
};

// Blocked = 28, Pending = 29, Draft = 30, Active = 31, Inactive = 32, Deleted = 33, Pause = 42
export const useIsDraftOrPendingAccount = () => {
  const serverContext = useContext(DataServiceContext);
  if (serverContext.CurrentAccount && !_.isUndefined(serverContext.CurrentAccount.Status)) {
    return serverContext.CurrentAccount.Status === 29 || serverContext.CurrentAccount.Status === 30;
  }
  return false;
};
